import { Modal, ModalProps } from "antd"
import { useTranslation } from "react-i18next"
import { useDeleteMySubstitution } from "./queries"

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}
const DeleteMySubstitution: React.FC<Props> = ({ data: id, ...props }) => {
  const { t } = useTranslation()
  const { mutate, isLoading } = useDeleteMySubstitution({
    meta: {
      type: "delete",
      entity: t("assignations.substitution_one"),
      context: "female",
      count: 1,
    },
  })

  const onSubmit = () => {
    mutate(id!, {
      onSettled() {
        props.onClose()
      },
    })
  }

  return (
    <Modal
      title={t("global.deleteX", {
        entity: t("assignations.substitution_one"),
        context: "female",
        count: 1,
      })}
      okType="danger"
      onOk={onSubmit}
      okText={t("global.delete")}
      confirmLoading={isLoading}
      onCancel={props.onClose}
      cancelText={t("global.cancel")}
      {...props}
    >
      <p style={{ marginTop: "var(--size-6)" }}>{t("global.deleteRecord")}</p>
    </Modal>
  )
}

export default DeleteMySubstitution
